import React from 'react';
import UndoIcon from '@mui/icons-material/Undo';
import { IconButton, Stack, TextField, Tooltip, Typography } from '@mui/material';
import { ConfidenceBadge } from './ConfidenceBadge';
import { FieldEditState } from '../types';

interface EditableFieldRowProps {
  field: FieldEditState;
  onChange: (key: string, value: string) => void;
  onRevert: (key: string) => void;
}

export const EditableFieldRow = ({ field, onChange, onRevert }: EditableFieldRowProps) => (
  <Stack direction="row" spacing={2} alignItems="center" sx={{ py: 1 }}>
    <Typography variant="subtitle2" color="text.secondary" sx={{ minWidth: 200, flexShrink: 0 }}>
      {field.label}
    </Typography>
    <TextField
      size="small"
      variant="outlined"
      fullWidth
      value={field.currentValue}
      placeholder="Not extracted — click to add"
      onChange={e => onChange(field.key, e.target.value)}
      sx={{ maxWidth: 464 }}
    />
    {field.isDirty && (
      <Stack direction="row" spacing={0.25} alignItems="center" sx={{ flexShrink: 0 }}>
        <Typography variant="caption" sx={{ color: 'info.main', fontWeight: 500 }}>
          Edited
        </Typography>
        <Tooltip title="Revert to extracted value">
          <IconButton size="small" onClick={() => onRevert(field.key)}>
            <UndoIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Stack>
    )}
    <ConfidenceBadge confidence={field.confidence} />
  </Stack>
);
